'use client'

import * as React from 'react'
import { EventArgs, sendEvent } from 'basehub/events'

type PageViewProps<T extends Parameters<typeof sendEvent>[0]> =
  EventArgs<T>[1] extends undefined
    ? { ingestKey: T } // args is not required
    : { ingestKey: T; args: EventArgs<T>[1] } // args is required

export const PageView = <T extends Parameters<typeof sendEvent>[0]>(
  params: PageViewProps<T>
) => {
  const hasSentRef = React.useRef(false)

  React.useEffect(() => {
    if (hasSentRef.current) return
    hasSentRef.current = true
    const ingestKey = params.ingestKey

    if ('args' in params) {
      const args = params.args

      sendEvent(...([ingestKey, args] as Parameters<typeof sendEvent>))
    } else {
      sendEvent(...([ingestKey] as unknown as Parameters<typeof sendEvent>))
    }
  }, [params])

  return null
}
